import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hotel-pretrip',
  templateUrl: './hotel-pretrip.component.html',
  styleUrls: ['./hotel-pretrip.component.scss']
})
export class HotelPretripComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
